import script from "./QuestionYesNo.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionYesNo.vue?vue&type=script&setup=true&lang=js"

import "./QuestionYesNo.vue?vue&type=style&index=0&id=1815990a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1815990a"]])

export default __exports__